module.exports = __webpack_public_path__ + "img/Purple_s.8bda0169.svg";